import { LiaTimesSolid } from "react-icons/lia";
import { FaLanguage } from "react-icons/fa6";
import { FaCalendar } from "react-icons/fa";
import { FaGlobe } from "react-icons/fa";
import { FaPalette } from "react-icons/fa6";
import { FaSun } from "react-icons/fa";
import { FaMoon } from "react-icons/fa";
import { useState } from "react";


export default function Settings({setOpenSettings, openSettings = true}) {
    const [language, setLanguage] = useState("fa");
    const [calendar, setCalendar] = useState("gregorian");
    const [region, setRegion] = useState("ir");
    const [theme, setTheme] = useState("light");

    return (
        <div dir="ltr" className={`fixed inset-0 z-50 transition-colors duration-300 ${openSettings ? 'bg-black/50' : 'bg-transparent pointer-events-none'}`} onClick={() => setOpenSettings(false)}>
            <div className={`fixed top-0 left-0 bottom-0 w-[85%] max-w-md bg-white transform transition-all duration-300 ease-out flex flex-col ${openSettings ? 'translate-x-0' : '-translate-x-full'}`} onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between p-6 border-b border-gray-100">
                    <h3 className="text-xl font-bold text-gray-900">Settings</h3>
                    <button onClick={() => setOpenSettings(false)} className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                        <LiaTimesSolid className="fa-solid fa-times text-gray-600"/>
                    </button>
                </div>

                <div className="flex-1 overflow-y-auto p-6 space-y-4">
                    {/* <div className="bg-white rounded-2xl border border-gray-200 p-5">
                        <div className="flex items-center mb-4">
                            <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center mr-3">
                                <FaLanguage className="fa-solid fa-language text-blue-600"/>
                            </div>
                            <h4 className="font-semibold text-gray-900">Language</h4>
                        </div>
                        <div className="space-y-2">
                            <label className="flex items-center justify-between p-3 bg-gray-50 rounded-xl cursor-pointer hover:bg-gray-100 transition-colors">
                                <span className="text-gray-700">English</span>
                                <input type="radio" name="language" value="en" checked={language === "en"} onChange={(e) => setLanguage(e.target.value)} className="w-5 h-5 text-primary"/>
                            </label>
                            <label className="flex items-center justify-between p-3 bg-gray-50 rounded-xl cursor-pointer hover:bg-gray-100 transition-colors">
                                <span className="text-gray-700">فارسی</span>
                                <input type="radio" name="language" value="fa" checked={language === "fa"} onChange={(e) => setLanguage(e.target.value)} className="w-5 h-5 text-primary"/>
                            </label>
                            <label className="flex items-center justify-between p-3 bg-gray-50 rounded-xl cursor-pointer hover:bg-gray-100 transition-colors">
                                <span className="text-gray-700">العربية</span>
                                <input type="radio" name="language" value="ar" checked={language === "ar"} onChange={(e) => setLanguage(e.target.value)} className="w-5 h-5 text-primary"/>
                            </label>
                        </div>
                    </div> */}

                    <div className="bg-white rounded-2xl border border-gray-200 p-5">
                        <div className="flex items-center mb-4">
                            <div className="w-10 h-10 bg-green-50 rounded-xl flex items-center justify-center mr-3">
                                <FaCalendar className="fa-solid fa-calendar text-green-600"/>
                            </div>
                            <h4 className="font-semibold text-gray-900">Calendar</h4>
                        </div>
                        <div className="space-y-2">
                            <label className="flex items-center justify-between p-3 bg-gray-50 rounded-xl cursor-pointer hover:bg-gray-100 transition-colors">
                                <span className="text-gray-700">Gregorian</span>
                                <input type="radio" name="calendar" value="gregorian" checked={calendar === "gregorian"} onChange={(e) => setCalendar(e.target.value)} className="w-5 h-5 text-primary"/>
                            </label>
                            <label className="flex items-center justify-between p-3 bg-gray-50 rounded-xl cursor-pointer hover:bg-gray-100 transition-colors">
                                <span className="text-gray-700">Shamsi</span>
                                <input type="radio" name="calendar" value="shamsi" checked={calendar === "shamsi"} onChange={(e) => setCalendar(e.target.value)} className="w-5 h-5 text-primary"/>
                            </label>
                            <label className="flex items-center justify-between p-3 bg-gray-50 rounded-xl cursor-pointer hover:bg-gray-100 transition-colors">
                                <span className="text-gray-700">Hijri</span>
                                <input type="radio" name="calendar" value="hijri" checked={calendar === "hijri"} onChange={(e) => setCalendar(e.target.value)} className="w-5 h-5 text-primary"/>
                            </label>
                        </div>
                    </div>

                    <div className="bg-white rounded-2xl border border-gray-200 p-5">
                        <div className="flex items-center mb-4">
                            <div className="w-10 h-10 bg-purple-50 rounded-xl flex items-center justify-center mr-3">
                                <FaGlobe className="fa-solid fa-globe text-purple-600"/>
                            </div>
                            <h4 className="font-semibold text-gray-900">Region</h4>
                        </div>
                        <select value={region} onChange={(e) => setRegion(e.target.value)} className="w-full p-3 bg-gray-50 rounded-xl border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary">
                            <option value="us">United States</option>
                            <option value="uk">United Kingdom</option>
                            <option value="ir">Iran</option>
                            <option value="ae">United Arab Emirates</option>
                            <option value="sa">Saudi Arabia</option>
                            <option value="tr">Turkey</option>
                            <option value="de">Germany</option>
                            <option value="fr">France</option>
                            <option value="jp">Japan</option>
                            <option value="cn">China</option>
                        </select>
                    </div>

                    <div className="bg-white rounded-2xl border border-gray-200 p-5">
                        <div className="flex items-center mb-4">
                            <div className="w-10 h-10 bg-orange-50 rounded-xl flex items-center justify-center mr-3">
                                <FaPalette className="fa-solid fa-palette text-orange-600"/>
                            </div>
                            <h4 className="font-semibold text-gray-900">Theme</h4>
                        </div>
                        <div className="flex gap-3">
                            <label className="flex-1 justify-center items-center p-4 bg-gray-50 rounded-xl cursor-pointer hover:bg-gray-100 transition-colors text-center border-2 border-primary">
                                <FaSun className="fa-solid w-full text-center fa-sun text-2xl text-yellow-500 mb-2"/>
                                <div className="text-sm font-medium text-gray-700">Light</div>
                                <input type="radio" name="theme" value="light" checked="" className="hidden"/>
                            </label>
                            <label className="flex-1 justify-center items-center p-4 bg-gray-50 rounded-xl cursor-pointer hover:bg-gray-100 transition-colors text-center border-2 border-transparent">
                                <FaMoon className="fa-solid w-full fa-moon text-2xl text-indigo-600 mb-2"/>
                                <div className="text-sm font-medium text-gray-700">Dark</div>
                                <input type="radio" name="theme" value="dark" className="hidden"/>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}